import { Drawer, IconButton, styled } from '@mui/material';

export const SIDEBAR_DESKTOP = {
  width: '240px',
};

export const BOTTOM_MENU_HEIGHT = '190px';

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== '$isOpen',
})<{ $isOpen: boolean }>(({ theme, $isOpen }) => ({
  zIndex: 1000,
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.primary.main,
    overflow: 'hidden',
    borderRight: `0.0625rem solid ${theme.palette.common.white}`,
    transition: theme.transitions.create('width', {
      duration: $isOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
      easing: theme.transitions.easing.sharp,
    }),
    width: $isOpen ? '100%' : 0,
    [theme.breakpoints.up('md')]: {
      width: SIDEBAR_DESKTOP.width,
    },
  },
}));

const DrawerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: `${theme.spacing(2)} 0 ${theme.spacing(1)}`,
  position: 'relative',
  minHeight: '100vh',
}));

const CloseButtonContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  color: `${theme.palette.common.white} !important`,
  height: '1.625rem !important',
  width: '1.625rem !important',
}));

const CompanyLogoContainer = styled('div')({
  alignItems: 'center',
  backgroundColor: 'transparent',
  display: 'flex',
  justifyContent: 'center',
});

const DrawerBottom = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
  height: `calc(100% - ${BOTTOM_MENU_HEIGHT})`,
});

const Bottom = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(1),
  minHeight: 'auto',
}));

export {
  StyledDrawer,
  DrawerContainer,
  CloseButtonContainer,
  StyledCloseButton,
  CompanyLogoContainer,
  DrawerBottom,
  Bottom,
};
// import { createStyles, makeStyles } from '@mui/styles';
// import { ITheme } from 'theme/types';

// export const SIDEBAR_DESKTOP = {
//   width: '240px',
// };

// export const BOTTOM_MENU_HEIGHT = '190px';

// const useStyles = makeStyles((theme: ITheme) =>
//   createStyles({
//     drawer: {
//       zIndex: 1000,
//       backgroundColor: theme.palette.primary['600'],
//       overflow: 'hidden',

//       [theme.breakpoints.up('md')]: {
//         borderRight: `1px solid ${theme.palette.white} !important`,
//       },
//     },

//     openingDrawer: {
//       transition: theme.transitions.create('width', {
//         duration: theme.transitions.duration.enteringScreen,
//         easing: theme.transitions.easing.sharp,
//       }),
//       width: '100%',
//       [theme.breakpoints.up('md')]: {
//         ...SIDEBAR_DESKTOP,
//       },
//     },
//     closingDrawer: {
//       transition: theme.transitions.create('width', {
//         duration: theme.transitions.duration.leavingScreen / 2,
//         easing: theme.transitions.easing.sharp,
//       }),
//       width: 0,
//       [theme.breakpoints.up('md')]: {
//         ...SIDEBAR_DESKTOP,
//       },
//     },

//     drawerContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       height: '100%',
//       padding: `${theme.spacing(2)}px 0 ${theme.spacing(1)}px`,
//       position: 'relative',
//       minHeight: '100vh',
//     },

//     closeButtonContainer: {
//       alignItems: 'center',
//       display: 'flex',
//       justifyContent: 'center',
//       marginBottom: theme.spacing(1),

//       [theme.breakpoints.up('md')]: {
//         display: 'none',
//       },
//     },
//     closeButton: {
//       color: theme.palette.white,
//       height: '26px',
//       width: '26px',
//     },

//     drawerTop: {},

//     companyLogoContainer: {
//       alignItems: 'center',
//       backgroundColor: 'transparent',
//       display: 'flex',
//       justifyContent: 'center',
//     },

//     drawerBottom: {
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       flexGrow: 1,
//       height: `calc(100% - ${BOTTOM_MENU_HEIGHT})`,
//     },
//     bottom: {
//       // zIndex: 1000,
//       paddingBottom: theme.spacing(1),
//       minHeight: BOTTOM_MENU_HEIGHT,
//     },
//   })
// );

// export default useStyles;
